//@flow
import * as React from 'react';

import { selectWithButtonFactory } from 'common/components/core/select';
import { ButtonTypes } from 'common/components/core/button';

import type { ZoneMapFolder } from 'common/models/internal/ZoneMapFolder';
import theme from './FolderSelector.scss';
import DefaultSelectComponents from 'common/components/core/select/DefaultSelectComponents';
import { ListCard } from 'common/components/core/card/ListCard';

type Props = {
    theme: Object,
    selectedFolder?: string,
    folders: Array<ZoneMapFolder>,
    noOptionsMessage: () => string,
    onChange: () => void
};

const FolderOption = props => <ListCard {...props} leftIcon="folder-close" />;

const SelectWithButton = selectWithButtonFactory({
    Option: DefaultSelectComponents.optionFactory(FolderOption)
});

class FolderSelector extends React.PureComponent<Props> {
    getOptionValue(option) {
        return option.id;
    }
    getOptionLabel(option) {
        return option.name;
    }
    render() {
        const {
            folders,
            selectedFolder,
            onChange,
            noOptionsMessage,
            helpText
        } = this.props;
        return (
            <SelectWithButton
                isSearchable={false}
                isClearable={false}
                menuAutoWidth
                theme={theme}
                icon="add-folder"
                ripple={false}
                className={theme.folders}
                buttonType={ButtonTypes.Icon}
                buttonClassName={theme.foldersBtn}
                options={folders.toArray()}
                value={selectedFolder}
                getOptionValue={this.getOptionValue}
                getOptionLabel={this.getOptionLabel}
                onChange={onChange}
                noOptionsMessage={noOptionsMessage}
                menuHelpText={helpText}
            />
        );
    }
}

export default FolderSelector;
